import { render } from "./BookingsList.vue?vue&type=template&id=f2600c52&ts=true"
import script from "./BookingsList.vue?vue&type=script&lang=ts"
export * from "./BookingsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__